export const titles = {
  Día: 'Fecha',
  'Calle Cliente': 'Datos del Cliente',
  'Rut Usuario': 'Datos del Usuario. (Solo llenar en caso de ser diferente a datos de facturación)',
  'CTAS Relacionadas': 'CTAS Relacionadas. (N° Contrato)',
  'Reacción Móvil': 'Tipos de Servicios',
  'Conexión Telefónica': 'Tipo de Conexión',
  'Tipo de usuario Residencial': 'Tipo de Usuario',
  'Centro pago': 'Forma de Pago',
  'Central de alarma': 'Equipamiento de alarma entregado comodato',
  'Nombre persona autorizada 1': 'Nomina personas autorizadas para operar el sistema de alarmas',
  'Nombre persona emergencia 1': 'Nomina personas relacionadas para llamar en caso de emergencia',
  'Nombre emergencia médica 1': 'Emergencias médicas',
  'Llaves domicilio': 'Llaves domicilio (Nombre y teléfono)',
  Nuevo: 'Tipo de operación',
  'Nombre persona autorizada 2': 'Autorización 2',
  'Nombre persona autorizada 3': 'Autorización 3',
  'Nombre persona autorizada 4': 'Autorización 4',
  'Nombre persona autorizada 5': 'Autorización 5',
  'Nombre persona autorizada 6': 'Autorización 6',
  'Nombre persona emergencia 2': 'Autorización de emergencia 2',
  'Nombre persona emergencia 3': 'Autorización de emergencia 3',
  'Nombre persona emergencia 4': 'Autorización de emergencia4',
  'Nombre emergencia médica 2': 'Autorización médica 2'
}



// WEBPACK FOOTER //
// ./src/App/components/FormFields/titles.js